<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Press Releases</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div v-if="lastedNewList.length > 0">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Official Press Release </span>

        <div class="my-4 ">
          <div
            class="row align-items-center my-1  news-card-effect pointer text-lg-left text-center"
            v-for="item in lastedNewList"
            @click.prevent="goLastedNewsDetial(item.NewsNo)"
          >
            <div class="col-lg-3">
              <div class="OfficiallogImgFrame">
                <img :src="`//www.chanchao.com.tw/exhibitionfiles/news/${item.NewsImg}`" width="75%" class="pointer" />
              </div>
            </div>
            <div class="col-lg-9">
              <p class="h5 title_fontStyle">
                {{ item.Topic }}
              </p>
              <p>
                {{ item.Brief }}
              </p>
              <p class="text-muted">
                {{ item.PostDate }}
              </p>
            </div>
          </div>
        </div>
        <p>&zwnj;</p>
      </div>

      <span class="h2 title_fontStyle my-5"><i class="fas fa-caret-right"></i> Exhibitor Press Release</span>

      <div class="PcDevice my-5">
        <div
          class="row align-items-center border-bottom my-1 news-card-effect pointer"
          v-for="item in newsList"
          @click.prevent="goNewsDetial(item.NewsNo)"
        >
          <div class="col-lg-3 ">
            <div class="logImgFrame">
              <img
                :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.ComLogo}`"
                width="65%"
                class="pointer"
              />
            </div>
          </div>
          <div class="col-lg-9">
            <p class="h5 title_fontStyle ">
              {{ item.NewsTopic }}
            </p>
            <p>
              {{ item.ComName }}
            </p>
            <p class="text-muted">
              {{ item.UpdateTime }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="MbDevice my-5">
      <div v-for="item in newsList" class="mx-5 my-3" @click.prevent="goNewsDetial(item.NewsNo)">
        <div>
          <div class="d-flex justify-content-center align-items-center">
            <div class="  text-center">
              <div class="lineStyle align-items-center">
                <div>
                  <div class="logImgFrame">
                    <img
                      :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.ComLogo}`"
                      width="65%"
                      class="pointer"
                    />
                  </div>
                </div>
                <div>
                  <p class="h5 title_fontStyle ">
                    {{ item.NewsTopic }}
                  </p>
                  <p>
                    {{ item.ComName }}
                  </p>
                  <p class="text-muted">
                    {{ item.UpdateTime }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>

      <p>&zwnj;</p>
      <p>&zwnj;</p>
    </div>

    <div class="PcDevice">
      <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
        <nav>
          <ul class="pagination pointer">
            <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
              <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
              </span>
            </li>
            <li class="page-item" :class="{ disabled: currentPage == 1 }">
              <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
              </span>
            </li>
            <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
              <span class="page-link" @click="getPage(page)">{{ page }}</span>
            </li>

            <li class="page-item" :class="{ disabled: currentPage == totalPage }">
              <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
              </span>
            </li>
            <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == totaltenPageNum - 1 }">
              <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
              </span>
            </li>
          </ul>
          <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
          <p>&zwnj;</p>
        </nav>
      </div>
    </div>

    <div class="MbDevice">
      <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
        <nav>
          <ul class="pagination pagination-sm pointer">
            <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
              <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
              </span>
            </li>
            <li class="page-item" :class="{ disabled: currentPage == 1 }">
              <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
              </span>
            </li>
            <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
              <span class="page-link" @click="getPage(page)">{{ page }}</span>
            </li>

            <li class="page-item" :class="{ disabled: currentPage == totalPage }">
              <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
              </span>
            </li>
            <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == totaltenPageNum - 1 }">
              <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
              </span>
            </li>
          </ul>
          <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
          <p>&zwnj;</p>
        </nav>
      </div>
    </div>

    <p>&zwnj;</p>
    <p>&zwnj;</p>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'
  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        newsList: [],
        lastedNewList: [],
        currentPage: 2,
        totalPage: '',
        totalNo: '',
        ProductRawData: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },
    methods: {
      goNewsDetial(id) {
        this.$router.push(`/PressReleaseDetail/${id}`)
      },

      goLastedNewsDetial(id) {
        this.$router.push(`/OfficialNewsDetail/${id}`)
      },

      //分頁

      getPage(page) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/PressReleases/Page=${page}`
      },

      nextPage() {
        const vm = this
        let nextP = Number(vm.currentPage) + 1

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/PressReleases/Page=${nextP}`
      },

      lastPage() {
        const vm = this
        let lastP = Number(vm.currentPage) - 1

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/PressReleases/Page=${lastP}`
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/PressReleases/Page=${vm.currentPage}`
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/PressReleases/Page=${vm.currentPage}`
      },
    },

    created() {
      $('.modal').modal('hide')
      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      const vm = this

      vm.currentPage = vm.$route.params.NewsPage

      vm.$store.dispatch('updateLoading', true)

      //取得最新消息列表
      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/LatestNews/${vm.exhcode}?Type=Press&Lang=en`)
        .then((response) => {
          vm.lastedNewList = response.data
            .filter((item) => {
              return item.archived == 1
            })
            .filter((item) => {
              return item.PostDate.split('-')[0] > 2020
            })

          vm.$http
            .get(
              `https://www.chanchao.com.tw/apiOnlineExpo/v1/PressReleases/${vm.exhcode}?Regno=&Page=${vm.currentPage}&Lang=en`
            )
            .then((response) => {
              vm.$store.dispatch('updateLoading', false)

              vm.totalNo = response.data.DataTotal

              if (response.data.PageTotal > 0) {
                vm.newsList = response.data.PressReleases
                vm.totalPage = response.data.PageTotal

                for (let i = 0; i < vm.totalPage; i++) {
                  if (i % 10 === 0) {
                    vm.ProductRawData.push([])
                  }

                  const page = parseInt(i / 10)
                  vm.ProductRawData[page].push(i + 1)
                }

                vm.totaltenPageNum = vm.ProductRawData.length

                let anaNowPage = vm.currentPage - 1

                vm.tenPageNum = parseInt(anaNowPage / 10)
                vm.showpage = vm.ProductRawData[vm.tenPageNum]
              }
            })
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss">
  .OfficiallogImgFrame {
    width: 200px;
    min-height: 200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logImgFrame {
    width: 200px;
    min-height: 175px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .news-card-effect {
    &:hover {
      filter: brightness(1.1);
      box-shadow: 1px 1px 10px 1px #dddddd;
    }
  }

  .lineStyle {
    display: block;
    margin-bottom: 25px;
  }
</style>
